import type {Dispatch, SetStateAction} from 'react';

import type {AfriexReferralTier} from '@/types';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

export type TierListProps<T> = {
  /** Whatever the fetch threw. A caught value is `unknown`, not an `Error`. */
  error: unknown;
  /**
   * Every hook behind this type supplies an async fetcher, and the tests
   * already `await` it. The old `=> void` hid that: it made the promise
   * invisible at each `fetchList: fetchX` site instead of letting callers
   * decide what to do with it. The only render-side consumer casts it to
   * `PaginationProps['onPageChange']`, so widening the declaration here does
   * not change any call site.
   */
  fetchList: (params: AfriexQueryParams) => Promise<void>;
  isLoading: boolean;
  page: number;
  setPage: (page: number) => void;
  total: number;
  list: T[];
};

/**
 * Shared by the single and bulk tier-user upload forms, which render the same
 * fields and are both fed from `useTierUserUpdate`.
 */
export type TierUserUploadFormProps = {
  onClose: VoidFunction;
  userEmail: string;
  handleSubmit: () => Promise<void>;
  setUserEmail: Dispatch<SetStateAction<string>>;
  isDisabled: boolean;
  submitLabel: string;
};

export enum TierActionType {
  UPDATE_TIER = 'UPDATE_TIER',
}

export interface UpdateTierAction {
  type: TierActionType.UPDATE_TIER;
  payload: Partial<AfriexReferralTier>;
}

export type TierAction = UpdateTierAction;
